// extracted by mini-css-extract-plugin
export default {"deskLogo":"navBar_deskLogo__EYcS0","mobileLogo":"navBar_mobileLogo__BDPp1"};